import React, { useState, useEffect } from 'react';
import ImageTag from '../ImageTag/Index';
import './index.css';
import BreadCrumbs from '../BreadCrumb/Index';

const Index = ({ Data, positionText }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // Standard mobile breakpoint
    };

    // Initial check
    checkScreenSize();

    // Add event listener
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Process heading content based on screen size
  const processHeading = (content) => {
    if (!content) return '';
    if (isMobile) {
      // Remove <br> tags on mobile and replace with space
      return content.replace(/<br\s*\/?>/gi, ' ');
    }
    return content;
  };

  const processedHeading = Data?.heading ? processHeading(Data.heading) : '';

  return (
    <section className='col-12 float-start flex-center overflow-hidden flex-wrap'>
      <div className='col-12 float-start InternalBanner position-relative'>
        {Data?.imagePath || Data?.mobileImagePath ? (
          <>
            <ImageTag
              ImagePath={Data.imagePath}
              ImageAlt={Data.imageAlt}
              ImageWidth='1920'
              ImageHeight='550'
              ImageClass="desktop-show"
            />
            <ImageTag
              ImagePath={Data.mobileImagePath}
              ImageAlt={Data.imageAlt}
              ImageWidth='630'
              ImageHeight='450'
              ImageClass="mobile-show"
            />
          </>
        ) : (
          <div className='col-12 float-start Noimage flex-center'>
            <ImageTag ImageAlt='No Image Found' />
          </div>
        )}

        {processedHeading && (
          <h1
            className={`heading position-absolute text-white greenBorder d-block px-lg-4 px-2 ${positionText}`}
            dangerouslySetInnerHTML={{ __html: processedHeading }}
          />
        )}
      </div>

      <BreadCrumbs _parentClass='col-12 float-start' />
    </section>
  );
};

export default Index;